export const ImportReportInitialState = {
   deletedAccounts: 0,
   deletedCreditInquiries: 0,
   newNegativeAccounts: 0,
   newPositiveAccounts: 0,
   newCreditInquiries: 0,
   updatedAccounts: 0,
};